<template>
  <div>
    <div class="static-north-box" v-if="minimap.staticNorth">
      <svg
        v-if="minimap.northAngle != null"
        width="54"
        height="54"
        viewBox="0 0 47 47"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="compass"
      >
        <!--  <rect x=".655" width="35" height="35" rx="17.5" fill="#fff"/>-->
        <circle cx="23.5" cy="23.5" r="23" fill="#f5f5f5"/>
        <path transform="translate(10, 10) scale(0.8)"
              d="M24.125 24.49h-2.8l-6.34-9.58v9.58h-2.8V10.51h2.8l6.34 9.6v-9.6h2.8v13.98z"
              fill="#000"/>
        <path d="m25.5 12 4-10 5 11h-10z" fill="#F40000"
              :transform="`rotate(${minimap.northAngle}, 24.5, 22.5)  scale(0.8)` "/>
      </svg>
    </div>
    <marzipano-minimap
      v-else
      :data="minimap"
      :active-hotspot="activeHotspot"
      :style="positionStyle"
      :navigate="navigate"
      :open-icon="icon"
    />
  </div>
</template>

<script>
import MarzipanoMinimap from '@/components/marzipano/MarzipanoMinimap.vue';
import { mapGetters } from 'vuex';
import { imageUrl } from '@/utils/urls';

export default {
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  components: { MarzipanoMinimap },
  computed: {
    ...mapGetters('exteriors', ['minimap', 'currentExterior']),
    activeHotspot() {
      // emulate a Hotspot object
      return { id: this.currentExterior.exterior_id };
    },
    positionStyle() {
      return this.fixed
        ? {
          position: 'fixed',
          marginTop: '56px',
        }
        : {};
    },
    icon() {
      return imageUrl('img/exterior-minimap/exterior-minimap.svg');
    },
  },
  methods: {
    navigate(hotspot) {
      this.$router.push({ name: 'order.overview.exterior', params: { exteriorId: +hotspot.id } });
    },
  },
};
</script>

<style scoped lang="scss">
.static-north-box {
  position: fixed;
  margin-top: 56px;
  right: 15px;
  top: 15px;
  z-index: 1;
  & svg {
    border-radius: 50%;
    box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12);
  }
}
</style>
